import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from '../adapter-registry';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { Model } from '../../backendmodel';
import { FMLVLinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FMLVLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {},
            parameters: '*'
        }
    }
})
export class FMLVLinkedServiceAdapter extends LinkedServiceAdapter<FMLVLinkedService> {

    protected modelConstructor(): new () => FMLVLinkedService {
        return FMLVLinkedService; 
    }

    protected model(): IModel {
        return FMLVLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(_linkedService: FMLVLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(_linkedServiceResource: Model.LinkedServiceResource, linkedService: FMLVLinkedService): Promise<FMLVLinkedService> {
        return linkedService;
    }
}